import React from "react";

export default function BirthChildFrame1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1500 1500"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-1bir1{fill:#fff}.cls-1bir3{fill:#ff9ff8}.cls-1bir4{fill:#82f4f4}"
            }
          </style>
        </defs>
        <path
          d="M1289.56 280.83c-44.05-5.53-93.79-14.68-147.31-29.65-84-23.48-153.57-54.64-207.79-83.93-7.68-4.15-17.34-.17-19.56 8.01-19.05 70.28-84.23 121.3-159.37 123.62-79.12 2.44-150.32-49.69-170.43-123.7-2.21-8.15-11.89-12.08-19.54-7.94-54.22 29.3-123.79 60.45-207.8 83.94a1017.55 1017.55 0 0 1-147.31 29.65c-8.95 1.13-14.22 10.23-10.47 18.1 14.36 30.08 29.44 69.32 39 116.54 9.2 45.47 10.75 85.88 9.46 118.22-.37 9.13 8.98 15.72 17.94 12.63a612.826 612.826 0 0 1 58.23-16.91c22.57-5.36 43.74-9.04 63.09-11.56 7.72-1 14.71 4.45 15.24 11.9 6.88 98.56 9.39 206.69 4.54 322.94-3.2 76.73-9.3 149.42-17.33 217.7-.7 5.99 2.99 11.59 8.9 13.62 25.53 8.76 59.23 24.24 91.3 52.22 73.14 63.81 87.36 148.6 90.41 184.37.57 6.65 6.29 11.78 13.24 11.87l150.61 1.83v.13c1.8-.03 3.6-.05 5.39-.07 1.8.02 3.6.04 5.4.07v-.13l150.61-1.83c6.95-.09 12.67-5.22 13.24-11.87 3.05-35.77 17.26-120.56 90.41-184.37 32.07-27.98 65.77-43.46 91.3-52.22 5.91-2.03 9.6-7.63 8.9-13.62a2891.833 2891.833 0 0 1-17.33-217.7 2897.996 2897.996 0 0 1 4.54-322.94c.52-7.45 7.52-12.9 15.23-11.9 19.35 2.52 40.53 6.2 63.1 11.56a614.552 614.552 0 0 1 58.23 16.91c8.96 3.09 18.3-3.5 17.94-12.63-1.3-32.34.26-72.75 9.46-118.22 9.56-47.22 24.64-86.46 39-116.54 3.75-7.87-1.53-16.97-10.47-18.1Zm-328.98 755.81H539.42c-18.36 0-35.16-6.69-48.09-17.76-15.83-13.57-25.86-33.7-25.86-56.18v-30.17c6.92-3.86 11.6-11.26 11.6-19.75s-4.68-15.9-11.6-19.76V553.23a26.124 26.124 0 0 0 6.28-17.04c0-5-1.39-9.67-3.81-13.64 8.37-31.65 37.2-54.97 71.48-54.97h421.16c40.85 0 73.95 33.11 73.95 73.95V962.7c0 9.08-1.64 17.77-4.63 25.81-6.62 17.78-19.9 32.33-36.81 40.61-9.81 4.82-20.84 7.52-32.51 7.52Z"
          style={{
            fill: "#c071db",
          }}
        />
        <circle cx={523.49} cy={373.19} r={50.55} className="cls-1bir3" />
        <path
          d="M465.47 701.77v96.46c-20.5-6.45-35.36-25.6-35.36-48.23s14.86-41.78 35.36-48.23Z"
          className="cls-1bir3"
        />
        <circle cx={1184.12} cy={421.35} r={32.03} className="cls-1bir4" />
        <circle cx={1034.53} cy={423.74} r={50.55} className="cls-1bir3" />
        <circle cx={798.26} cy={1253.51} r={50.23} className="cls-1bir4" />
        <path
          d="M686.17 1045.25c0 12.5-10.13 22.63-22.63 22.63s-22.63-10.13-22.63-22.63c0-3.05.6-5.96 1.7-8.61h41.86c1.1 2.65 1.7 5.56 1.7 8.61ZM1049.36 862.22c0 9.75-6.18 18.07-14.83 21.24v-42.49c8.65 3.18 14.83 11.49 14.83 21.25Z"
          className="cls-1bir3"
        />
        <path
          d="M1069.65 680.51c0 19.4-15.72 35.12-35.12 35.12V645.4c19.4 0 35.12 15.72 35.12 35.11Z"
          className="cls-1bir4"
        />
        <circle cx={893.7} cy={1142.35} r={22.63} className="cls-1bir3" />
        <circle cx={741.85} cy={1142.35} r={22.63} className="cls-1bir3" />
        <path
          d="M477.07 912.78c0 8.49-4.68 15.89-11.6 19.75a22.482 22.482 0 0 1-11.03 2.87c-12.49 0-22.62-10.13-22.62-22.62s10.13-22.63 22.62-22.63c4 0 7.77 1.04 11.03 2.87 6.92 3.86 11.6 11.26 11.6 19.76Z"
          className="cls-1bir4"
        />
        <circle cx={629.28} cy={1168.01} r={34.26} className="cls-1bir4" />
        <path
          d="M541.9 1049.38c0 19.04-15.44 34.48-34.48 34.48s-34.48-15.44-34.48-34.48c0-13.23 7.45-24.72 18.39-30.5 12.93 11.07 29.73 17.76 48.09 17.76h.05c1.57 3.94 2.43 8.24 2.43 12.74Z"
          className="cls-1bir3"
        />
        <path
          d="M1060.98 1022.62c0 18.92-15.33 34.26-34.25 34.26-16.7 0-30.61-11.95-33.64-27.76 16.91-8.28 30.19-22.83 36.81-40.61 17.43 1.59 31.08 16.26 31.08 34.11ZM869.51 1038.6c0 19.05-15.43 34.48-34.47 34.48s-34.48-15.43-34.48-34.48c0-.66.02-1.31.05-1.96h68.85c.03.65.05 1.3.05 1.96Z"
          className="cls-1bir4"
        />
        <circle cx={943.85} cy={257.82} r={26.44} className="cls-1bir4" />
        <circle cx={878.73} cy={358.06} r={26.44} className="cls-1bir3" />
        <circle cx={419.2} cy={296.36} r={26.27} className="cls-1bir4" />
        <path
          d="M471.75 536.19c0 6.51-2.36 12.45-6.28 17.04-4.81 5.65-11.98 9.23-19.99 9.23-14.51 0-26.27-11.76-26.27-26.27s11.76-26.27 26.27-26.27c9.51 0 17.85 5.06 22.46 12.63 2.42 3.97 3.81 8.64 3.81 13.64Z"
          className="cls-1bir4"
        />
        <circle cx={1142.78} cy={307.5} r={26.44} className="cls-1bir3" />
        <circle cx={699.45} cy={396.49} r={26.44} className="cls-1bir3" />
        <path
          d="M886.77 467.58H783.3c0-28.57 23.16-51.73 51.74-51.73s51.73 23.16 51.73 51.73Z"
          className="cls-1bir4"
        />
        <circle cx={324.11} cy={423.74} r={34.19} className="cls-1bir4" />
        <path
          d="M471.75 536.19c0 6.51-2.36 12.45-6.28 17.04v-11.7c0-6.56.86-12.93 2.47-18.98 2.42 3.97 3.81 8.64 3.81 13.64ZM477.07 912.78c0 8.49-4.68 15.89-11.6 19.75v-39.51c6.92 3.86 11.6 11.26 11.6 19.76Z"
          className="cls-1bir1"
        />
        {children}
      </g>
    </svg>
  );
}
